module.exports = __webpack_public_path__ + "static/img/cycleai_logo.4e67cbe.png";